
import { Component, Vue } from "nuxt-property-decorator";
import OilImportTable from "~/components/organisms/table/OilImportTable.vue";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { FaqItem, JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
    OilImportTable,
  },
})
export default class PelletverbrauchRatgeber extends Vue {
  faqItems: FaqItem[] = [
    {
      question: "Wie lange reicht ein 15 kg Sack Pellets?",
      answer:
        "Für ein typisches 150 m² Einfamilienhaus mit einem Energieverbrauch von 90 kWh pro Quadratmeter ergibt sich ein jährlicher Pelletbedarf von etwa 2.700 kg. Das entspricht einem täglichen Verbrauch von rund 7,4 kg, sodass ein handelsüblicher 15 kg Sack Pellets etwa zwei Tage ausreicht. In den Wintermonaten kann der tägliche Verbrauch jedoch deutlich höher liegen, während er in der Übergangszeit entsprechend geringer ausfällt.",
    },
    {
      question: "Welcher Verbrauch ist normal für ein Einfamilienhaus?",
      answer:
        "Ein moderner Neubau nach KfW-55 Standard mit 150 m² Wohnfläche verbraucht typischerweise zwischen 1.500 und 2.000 kg Pellets pro Jahr. Sanierte Altbauten liegen meist im Bereich von 2.500 bis 4.000 kg jährlich, während unsanierte Bestandsgebäude durchaus 4.500 bis 6.000 kg und mehr benötigen können.",
    },
    {
      question: "Wie viel Lagerraum benötige ich?",
      answer:
        "Als Faustregel gilt, dass eine Tonne lose Pellets etwa 1,5 m³ Lagerraum beansprucht. Sackware benötigt aufgrund der Verpackung und der weniger dichten Lagerung etwa 20 % mehr Platz. Planen Sie grundsätzlich etwas großzügiger und kalkulieren Sie neben dem Jahresvorrat zusätzlich 20 % Reserve für besonders kalte Winter oder Lieferschwierigkeiten ein.",
    },
    {
      question: "Wann ist der beste Zeitpunkt zum Pelleteinkauf?",
      answer:
        "Die günstigsten Pelletpreise erzielen Sie typischerweise in den Frühjahrs- und Sommermonaten, wenn die Nachfrage gering ist. Im Herbst beginnen die Preise anzusteigen; in den Wintermonaten erreichen sie durch die Spitzennachfrage meist ihr Maximum.",
    },
  ];

  head() {
    return {
      ...generateMetaTags(this.$route.path, "pelletsverbrauch"),
      link: [{ rel: "canonical", href: this.$route.path }],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: this.faqItems.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          },
        },
      ],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Grundlagen",
        title: "Springen Sie zum Bereich: Grundlagen",
        href: { hash: "#anker-grundlagen" },
      },
      {
        name: "Berechnung",
        title: "Springen Sie zum Bereich: Berechnung",
        href: { hash: "#anker-berechnung" },
      },
      {
        name: "Praktischer Verbrauchsrechner",
        title: "Springen Sie zum Bereich: Praktischer Rechner",
        href: { hash: "#anker-rechner" },
      },
      {
        name: "Faktoren, die den Pelletverbrauch beeinflussen",
        title: "Springen Sie zum Bereich: Einflussfaktoren",
        href: { hash: "#anker-faktoren" },
      },
      {
        name: "Tipps zur Verbrauchsreduzierung",
        title: "Springen Sie zum Bereich: Tipps zur Reduzierung",
        href: { hash: "#anker-tipps" },
      },
      {
        name: "FAQ",
        title: "Springen Sie zum Bereich: Häufige Fragen",
        href: { hash: "#anker-faq" },
      },
      {
        name: "Kostenkalkulation und Wirtschaftlichkeit",
        title: "Springen Sie zum Bereich: Kosten & Wirtschaftlichkeit",
        href: { hash: "#anker-wirtschaftlichkeit" },
      },
      {
        name: "Effizient heizen, Kosten sparen",
        title: "Springen Sie zum Bereich: Aktionsplan",
        href: { hash: "#anker-aktionsplan" },
      },
    ];
  }
}
